import React from 'react'

const PermissionWarningBanner = ({
  permissionDetails = [],
  onGrantPermissions,
  isRequesting = false,
  lastCheckedAt = null,
}) => {
  if (permissionDetails.length === 0) {
    return null
  }

  return (
    <div className='permissionWarningBanner'>
      <div className='permissionWarningBanner-header'>
        <div className='permissionWarningBanner-title'>Bariyer Açma İçin İzin Gerekli</div>
        <button
          className='permissionWarningBanner-button'
          type='button'
          onClick={onGrantPermissions}
          disabled={isRequesting}
        >
          {isRequesting ? 'İstek Gönderildi...' : 'İzin Ver'}
        </button>
      </div>

      <ul className='permissionWarningBanner-tags'>
        {permissionDetails.map((detail) => (
          <li key={detail.key} className='permissionWarningBanner-tag'>
            <div style={{ display: 'flex', alignItems: 'flex-start', gap: '0.4rem' }}>
              <span aria-hidden style={{ flexShrink: 0 }}>⚠️</span>
              <div>
                <div style={{ fontWeight: 600 }}>{detail.label} izni kapalı</div>
                {detail.hint ? (
                  <div style={{ fontWeight: 400, opacity: 0.9, marginTop: 2 }}>{detail.hint}</div>
                ) : null}
              </div>
            </div>
          </li>
        ))}
      </ul>

      {lastCheckedAt ? (
        <div className='permissionWarningBanner-meta'>
          Son kontrol: {new Date(lastCheckedAt).toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit', second: '2-digit' })}
        </div>
      ) : null}
    </div>
  )
}

export default PermissionWarningBanner
